import { KeycloakProfile } from 'keycloak-js';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { StoreResponse, StoreResponses } from '@/stores/response';
import KeycloakService, { ExtendedKeycloakToken, ExtendedLoginOptions } from '@/services/KeycloakService';
import KeycloakUserRepresentation from '@/util/KeycloakUserRepresentation';
import ErrorKey from '@/util/ErrorKey';

@Module({
  namespaced: true,
  name: 'KeycloakStore',
})
export default class KeycloakStore extends VuexModule {
  public authenticated: boolean = false;
  public profile?: KeycloakProfile = KeycloakService.profile;

  @Mutation
  public setAuthenticated(authenticated: boolean) {
    this.authenticated = authenticated;
  }

  @Action
  public async login(options?: ExtendedLoginOptions): Promise<void> {
    return KeycloakService.login(options);
  }

  @Action
  public logout() {
    KeycloakService.logout();
  }

  @Action
  public async initialize(): Promise<StoreResponse<boolean>> {
    try {
      const authenticated = await KeycloakService.initOnce();
      this.context.commit('setAuthenticated', authenticated);
      return StoreResponses.success(authenticated);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.KeycloakInitializationAction);
    }
  }

  get token(): ExtendedKeycloakToken | null {
    return KeycloakService.parsedToken || null;
  }

  get currentUser(): KeycloakUserRepresentation {
    return {
      id: this.token?.sub ?? '',
      email: this.token?.email ?? '',
      firstName: this.token?.given_name ?? '',
      lastName: this.token?.family_name ?? '',
    };
  }

  get megacardRequested(): boolean {
    return this.token?.megacardRequestedAtRegister ?? false;
  }
}
